var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1157_9292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0005 36C27.9417 36 36.0006 27.9411 36.0006 18C36.0006 8.05887 27.9417 0 18.0005 0C8.05939 0 0.000488281 8.05887 0.000488281 18C0.000488281 27.9411 8.05939 36 18.0005 36Z",
    fill: "url(#paint0_linear_1157_9292)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0229 10.7109H11.9785C9.61543 10.7109 7.69983 12.6266 7.69983 14.9896V21.0106C7.69983 23.3737 9.6155 25.2893 11.9785 25.2893H24.0229C26.386 25.2893 28.3016 23.3736 28.3016 21.0106V14.9896C28.3016 12.6266 26.3859 10.7109 24.0229 10.7109ZM21.1292 18.293L15.4958 20.9798C15.3456 21.0514 15.1721 20.9421 15.1721 20.7758V15.2342C15.1721 15.0655 15.3501 14.9561 15.5005 15.0324L21.1339 17.8872C21.3017 17.972 21.2987 18.2123 21.1292 18.293Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1157_9292",
    x1: 18.0005,
    y1: 0,
    x2: 18.0005,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F32313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A01F15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1157_9292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.0001,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareYoutube);
export default __webpack_public_path__ + "static/media/share-youtube.94a3d7c48974ba79be16e26c1e65ff15.svg";
export { ForwardRef as ReactComponent };